module.exports = __webpack_public_path__ + "static/media/answerAuthorImage.7903d289.svg";